module.exports = __webpack_public_path__ + "img/kommune-604.64b383c3.svg";